import { LessVacancySection } from 'src/features/homeowners/components/less-vacancy-section/less-vacancy-section';

export const VacancyBannerSlice = () => <LessVacancySection />;
